export default "__VITE_ASSET__VmL3O5Xu__"